import Breadcrumbs from "./Breadcrumbs.vue";
export default {
  name: "v-template",
  components: {
    "v-breadcrumbs": Breadcrumbs
  },
  props: {
    breadcrumbs: Array
  },
  computed: {
    actualBreadcrumbs: function actualBreadcrumbs() {
      var _contextSettingsData;
      return this.breadcrumbs ? this.breadcrumbs : (_contextSettingsData = contextSettingsData) === null || _contextSettingsData === void 0 || (_contextSettingsData = _contextSettingsData.metadata) === null || _contextSettingsData === void 0 ? void 0 : _contextSettingsData.breadcrumbs;
    }
  }
};